import "../css/Inicio.css";
import Navbar1 from "../components/Navbar1";
import Navbar2 from "../components/Navbar2";
import Panel_Investigacion from "../components/Panel_Investigacion";
import Footer from "../components/Footer";

export default function Invetigacion() {
  return (
    <div className="Invetigacion">
      <Navbar1 />
      <Navbar2 />
      <Panel_Investigacion />
      <Footer />
    </div>
  );
}
